import React from 'react';

interface NewsTagsProps {
  tags: string[];
  className?: string;
}

const NewsTags: React.FC<NewsTagsProps> = ({ tags, className = '' }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {tags.map((tag, index) => (
        <span
          key={`${tag}-${index}`}
          className="h-[24px] md:h-[28px] flex items-center py-1 px-2 rounded-[20px] border border-[#E5E5E5] bg-white font-rubik font-normal text-[12px] md:text-[14px] leading-5 tracking-[0px] align-middle text-[#1A1A1A]"
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

export default NewsTags;

